import React from 'react';
import PropTypes from 'prop-types';
import noop from '../utils/noop';
import Preloader from '../design-system/components/preloader';

const LOADER_STEP = 13;

class Prealoder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      actualValue: 0,
      isActive: false,
    };

    this.updateLoaderState = this.updateLoaderState.bind(this);
    this.updateProgress = this.updateProgress.bind(this);
  }

  componentDidMount() {
    this.updateLoaderState();
  }

  componentDidUpdate(prevProps) {
    clearTimeout(this.tickTimer);

    this.updateLoaderState();

    const { value } = this.props;

    if (prevProps.value > value) {
      this.resetActualValue();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.tickTimer);
  }

  resetActualValue() {
    this.setState({ actualValue: 0 });
  }

  runLoader() {
    this.setState({
      isActive: true,
    });
  }

  stopLoader() {
    clearTimeout(this.tickTimer);

    this.setState({
      isActive: false,
    });
  }

  updateProgress() {
    const { actualValue } = this.state;

    this.setState({
      actualValue: actualValue + 1,
    });
  }

  updateLoaderState() {
    const { value } = this.props;
    const { actualValue, isActive } = this.state;

    if (value === null) {
      return null;
    }

    if (!isActive && actualValue < 100) {
      return this.runLoader();
    }

    if (isActive && actualValue >= 100) {
      return this.stopLoader();
    }

    if (value > actualValue) {
      this.tickTimer = setTimeout(this.updateProgress, LOADER_STEP);
    }

    return null;
  }

  render() {
    const { onAnimationEnd, initialValue } = this.props;
    const { actualValue } = this.state;

    return (
      <Preloader
        onAnimationEnd={onAnimationEnd}
        isAnimated={initialValue < actualValue}
        progress={initialValue > actualValue ? initialValue : actualValue}
      />
    );
  }
}

Prealoder.defaultProps = {
  onAnimationEnd: noop,
  value: null,
};

Prealoder.propTypes = {
  onAnimationEnd: PropTypes.func,
  value: PropTypes.number,
  initialValue: PropTypes.number.isRequired,
};

export default Prealoder;
